<body class="ltr main-body leftmenu">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <form autocomplete="off" class="p-0" novalidate [formGroup]="studentDataForm">
            <div class="col-lg-12 col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-9">
                      <div class="d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/purse.png" class="mh-45px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>STUDENT DATA UPLOAD REPORT</b></h3>
                          <p class="text-muted card-sub-title mb-0">Generate Student Data Upload Report</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row clearfix mt-2">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Select Session</mat-label>
                          <mat-select #select232 placeholder="Session" class="colorblack" formControlName="Session">
                            <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                              [displayMember]="'SnName'" [array]="sessionList"
                              (filteredReturn)="SessionFilterList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                              {{ item.SnNo }} - {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="studentDataForm.get('Session').hasError('required')">
                            Session is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Select Course</mat-label>
                          <mat-select #courseSelect placeholder="Course" class="colorblack" formControlName="course"
                            [disabled]="!studentDataForm.get('Session').value">
                            <mat-select-filter *ngIf="courseSelect.focused" [placeholder]="'Search Course...'"
                              [displayMember]="'CoName'" [array]="CourseList"
                              (filteredReturn)="filteredCourseList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCgCoCode">
                              {{ item.CoCgCoCode }} - {{ item.CoName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="studentDataForm.get('course').hasError('required')">
                            Course is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Select College</mat-label>
                          <mat-select formControlName="college" multiple
                            [disabled]="!studentDataForm.get('course').value" (selectionChange)="onCollegeSelect($event)">
                            <mat-select-filter *ngIf="true" [placeholder]="'Search College...'"
                              [displayMember]="'CgName'" [array]="collegeList"
                              (filteredReturn)="filteredCollegeList = $event"></mat-select-filter>
                            <mat-option (click)="selectAllColleges()" [value]="'selectAll'"
                              [checked]="isAllCollegesSelected()">
                              <strong>Select All Colleges</strong>
                            </mat-option>
                            <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode"
                              [checked]="selectedColleges.includes(item.CgCode)">
                              {{ item.CgCode }} - {{ item.CgName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="studentDataForm.get('college').hasError('required')">
                            College is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Select Exam</mat-label>
                          <mat-select formControlName="Exam" multiple placeholder="Exam" class="colorblack"
                            [disabled]="!canSelectExam()" (selectionChange)="onExamSelect($event)">
                            <mat-select-filter *ngIf="true" [placeholder]="'Search Exam...'"
                              [displayMember]="'EmName'" [array]="ExamAList"
                              (filteredReturn)="filteredExamAList = $event"></mat-select-filter>
                            <mat-option (click)="selectAllExams()" [value]="'selectAll'"
                              [checked]="isAllExamsSelected()">
                              <strong>Select All Exams</strong>
                            </mat-option>
                            <mat-option *ngFor="let item of filteredExamAList" [value]="item.EmId"
                              [checked]="selectedExams.includes(item.EmId)">
                              {{ item.EmCode }} - {{ item.EmName }}
                            </mat-option>
                            <mat-option *ngIf="canSelectExam() && ExamAList.length === 0" disabled>
                              No exams available for this course
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="studentDataForm.get('Exam').hasError('required')">
                            Exam is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                    <div class="row justify-content-center mt-4">
                    <div class="col-12 text-center">
                        <button type="button" class="btn btn-primary btn-lg px-5 mr-3"
                                (click)="generateReport()" [disabled]="studentDataForm.invalid || isGenerating">
                        <span *ngIf="!isGenerating">
                            <i class="fas fa-chart-bar mr-2"></i> Generate Report
                        </span>
                        <span *ngIf="isGenerating">
                            <i class="fas fa-spinner fa-spin mr-2"></i> Generating...
                        </span>
                        </button>
                        <button type="button" class="btn btn-primary btn-lg px-5 mr-3"
                                (click)="reset()" [disabled]="isGenerating">
                        <i class="fas fa-redo-alt mr-2"></i> Reset
                        </button>
                    </div>
                    </div>
                  <div class="row mt-5" *ngIf="reportData.length > 0">
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th>Sr No.</th>
                              <th>Name of College</th>
                              <th>Total Students</th>
                              <th>Photo & Sign Uploaded</th>
                              <th>Remaining</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of reportData; let i = index">
                              <td>{{ i + 1 }}</td>
                              <td>{{ item.CgName }}</td>
                              <td class="text-right">{{ item.TotalStudents }}</td>
                              <td class="text-right">{{ item.PhotoUploaded }}</td>
                              <td class="text-right">{{ item.PhotoRemaining }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="font-weight-bold">
                              <td colspan="2" class="text-right">Total</td>
                              <td class="text-right">{{ totalStudents }}</td>
                              <td class="text-right">{{ totalUploaded }}</td>
                              <td class="text-right">{{ totalRemaining }}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                </div> 
              </div> 
            </div> 
          </form>
        </div> 
      </div> 
    </div> 
  </div> 
</body>